// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pngIcon-module_pngIcon__ZHt4g {
    display: inline-block;
    position: relative;
    width: var(--size);
    height: var(--size);
    overflow: hidden;
    border-radius: 50%;
    vertical-align: top;
    flex-shrink: 0;

    &:before {
        border-width: 1px;
        border-style: solid;
        border-color: var(--grey_16_tr);
        border-radius: 50%;
        bottom: 0;
        content: '';
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
    }

    img {
        max-width: 100%;
    }
}

.pngIcon-module_disabled__utvw1 {
    opacity: 0.24;
}

.pngIcon-module_rightMargin__MD4sc {
    margin-right: 16px;
}`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/UI/FlagIcon/pngIcon.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;;IAEd;QACI,iBAAiB;QACjB,mBAAmB;QACnB,+BAA+B;QAC/B,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,OAAO;QACP,kBAAkB;QAClB,QAAQ;QACR,MAAM;IACV;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".pngIcon {\n    display: inline-block;\n    position: relative;\n    width: var(--size);\n    height: var(--size);\n    overflow: hidden;\n    border-radius: 50%;\n    vertical-align: top;\n    flex-shrink: 0;\n\n    &:before {\n        border-width: 1px;\n        border-style: solid;\n        border-color: var(--grey_16_tr);\n        border-radius: 50%;\n        bottom: 0;\n        content: '';\n        left: 0;\n        position: absolute;\n        right: 0;\n        top: 0;\n    }\n\n    img {\n        max-width: 100%;\n    }\n}\n\n.disabled {\n    opacity: 0.24;\n}\n\n.rightMargin {\n    margin-right: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pngIcon": `pngIcon-module_pngIcon__ZHt4g`,
	"disabled": `pngIcon-module_disabled__utvw1`,
	"rightMargin": `pngIcon-module_rightMargin__MD4sc`
};
export default ___CSS_LOADER_EXPORT___;
